import ValidationUtil from '../../common/utils/ValidationUtil'

export default (fieldName, value) => {
  switch (fieldName) {
    case 'address':
    case 'secondName':
    case 'city':
    case 'second':
      return ValidationUtil.validate(value)
    case 'state':
      return ValidationUtil.validate(value, 'state')
    case 'zip':
      return ValidationUtil.validate(value, 'zip')
    case 'tin':
    case 'secondTin':
      return ValidationUtil.validate(value, 'tin')
    case 'apt':
      return ValidationUtil.validate(value, 'number')
    default:
      return ValidationUtil.validate(value)
  }
}
